import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import IsIsntCard from './IsIsntCard';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
// Accounts created on/after launch (e.g. via Google) that never ticked "I understand" must do so once.
const ACK_REQUIRED_SINCE = '2026-11-02';

export default function EthosAckGate() {
  const { user, refreshUser } = useAuth();
  const [ack, setAck] = useState(false);
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  const needs = !!user && !user.ethos_ack_at && (user.created_at || '') >= ACK_REQUIRED_SINCE && !done;
  if (!needs) return null;
  const confirm = async () => {
    setSaving(true);
    try { await axios.post(`${API}/api/ethos/ack`); setDone(true); refreshUser?.(); }
    catch { toast.error('Could not save. Please try again.'); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open>
      <DialogContent className="sm:max-w-lg max-h-[90dvh] overflow-y-auto [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="ethos-ack-gate">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Playfair Display, serif' }}>Before you begin</DialogTitle>
          <DialogDescription>A quick word on what to expect from FBC.</DialogDescription>
        </DialogHeader>
        <IsIsntCard compact ack={ack} onAckChange={setAck} />
        <div className="flex justify-end">
          <Button disabled={!ack || saving} onClick={confirm} data-testid="ethos-ack-continue">Continue</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
